import React from "react";

const ProductRecommendationSlot = ({ hover }: { hover?: boolean }) => {
  if (hover) {

    return (
      <svg width="160" height="72" viewBox="0 0 160 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_15240_13873)">
<rect x="8.49805" y="6.5" width="46" height="33" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6"/>
<path d="M13 52.5H49C51.4853 52.5 53.5 54.5147 53.5 57C53.5 59.4853 51.4853 61.5 49 61.5H13C10.5147 61.5 8.5 59.4853 8.5 57C8.5 54.5147 10.5147 52.5 13 52.5Z" fill="#1879B9" stroke="#1879B9"/>
<rect x="7.99805" y="42" width="45" height="3" rx="1.5" fill="#DADEE6"/>
<rect x="7.99805" y="47" width="34.7091" height="3" rx="1.5" fill="#DADEE6"/>
<rect x="57.498" y="6.5" width="46" height="33" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6"/>
<path d="M62 52.5H98C100.485 52.5 102.5 54.5147 102.5 57C102.5 59.4853 100.485 61.5 98 61.5H62C59.5147 61.5 57.5 59.4853 57.5 57C57.5 54.5147 59.5147 52.5 62 52.5Z" fill="#1879B9" stroke="#1879B9"/>
<rect x="56.998" y="42" width="45" height="3" rx="1.5" fill="#DADEE6"/>
<rect x="56.998" y="47" width="34.7091" height="3" rx="1.5" fill="#DADEE6"/>
<rect x="106.502" y="6.5" width="45" height="33" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6"/>
<path d="M111 52.5H147C149.485 52.5 151.5 54.5147 151.5 57C151.5 59.4853 149.485 61.5 147 61.5H111C108.515 61.5 106.5 59.4853 106.5 57C106.5 54.5147 108.515 52.5 111 52.5Z" fill="#1879B9" stroke="#1879B9"/>
<rect x="105.998" y="42" width="45" height="3" rx="1.5" fill="#DADEE6"/>
<rect x="105.998" y="47" width="34.7091" height="3" rx="1.5" fill="#DADEE6"/>
</g>
<defs>
<filter id="filter0_d_15240_13873" x="-2" y="0" width="164" height="72" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="2"/>
<feGaussianBlur stdDeviation="4"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15240_13873"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15240_13873" result="shape"/>
</filter>
</defs>
</svg>

    );
  }

  return (
    <svg width="160" height="72" viewBox="0 0 160 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_15240_13848)">
        <rect x="8.49805" y="6.5" width="46" height="33" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6"/>
        <rect x="8.5" y="52.5" width="45" height="9" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6"/>
        <rect x="7.99805" y="42" width="45" height="3" rx="1.5" fill="#DADEE6"/>
        <rect x="7.99805" y="47" width="34.7091" height="3" rx="1.5" fill="#DADEE6"/>
        <rect x="57.498" y="6.5" width="46" height="33" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6"/>
        <rect x="57.5" y="52.5" width="45" height="9" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6"/>
        <rect x="56.998" y="42" width="45" height="3" rx="1.5" fill="#DADEE6"/>
        <rect x="56.998" y="47" width="34.7091" height="3" rx="1.5" fill="#DADEE6"/>
        <rect x="106.502" y="6.5" width="45" height="33" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6"/>
        <rect x="106.5" y="52.5" width="45" height="9" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6"/>
        <rect x="105.998" y="42" width="45" height="3" rx="1.5" fill="#DADEE6"/>
        <rect x="105.998" y="47" width="34.7091" height="3" rx="1.5" fill="#DADEE6"/>
      </g>
      <defs>
        <filter id="filter0_d_15240_13848" x="-2" y="0" width="164" height="72" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="4"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15240_13848"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15240_13848" result="shape"/>
        </filter>
      </defs>
  </svg>
  );
};

export default ProductRecommendationSlot;
